import { render, staticRenderFns } from "./PubPageList.vue?vue&type=template&id=67bcea9a&scoped=true&"
import script from "./PubPageList.vue?vue&type=script&lang=js&"
export * from "./PubPageList.vue?vue&type=script&lang=js&"
import style0 from "./PubPageList.vue?vue&type=style&index=0&id=67bcea9a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bcea9a",
  null
  
)

export default component.exports